import { render, staticRenderFns } from "./ComisionShow.vue?vue&type=template&id=24a541aa"
import script from "./ComisionShow.vue?vue&type=script&lang=js"
export * from "./ComisionShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports